import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, DEFAULT_NAMESPACE } from '../constants';
const DEBUG = process.env.BLAZE_TRANSLATION_DEBUG === 'true';
i18n.use(initReactI18next);
/**
 *  todo: add backend lazy loading
    .use(Backend)
    .use(LanguageDetector)
    import Backend from 'i18next-http-backend';
    import LanguageDetector from 'i18next-browser-languagedetector';
  */

const init = async ({
  primaryLanguage
}) => {
  const options = {
    lng: primaryLanguage || DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    // todo: check this initAsync option when we lazy load more it resolves initial SSR issues and speeds up init
    initAsync: false,
    defaultNS: DEFAULT_NAMESPACE,
    debug: DEBUG,
    partialBundledLanguages: true,
    keySeparator: false
  };
  if (DEBUG) console.time('i18n init'); // eslint-disable-line no-console
  await i18n.init(options);
  if (DEBUG) console.timeEnd('i18n init'); // eslint-disable-line no-console

  return i18n;
};
export default init;
//# sourceMappingURL=init.js.map